<template>
<div>
    <div>
      <div v-if="workshops.length === 0">
        <span class="text-muted regular-14">No result</span>
      </div>
      <div v-else v-for="(member, index) in workshops" :key="index">
        <b-card :class="index%2 === 1 ? 'bg-shade-2 mb-3' : 'bg-shade-1 mb-3'">
          <div class="row mb-2">
            <div class="col-md-12">
              <div class="regular-16 text-muted mb-2">
              <span>{{moment(member.from, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do, YYYY')}}</span>
              <span> - </span>
              <span>{{moment(member.to, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do, YYYY')}}</span>
            </div>
            <div class="bold-21">{{member.name}}</div>
            </div>
          </div>
          <div v-for="(item, index) in member.schedules" :key="index">
            <b-card no-body>
              <div class="d-flex mt-2 ml-5 mr-5">
                <div class="p-2 flex-grow-1">
                  <div class="text-center">
                    <div class="text-muted regular-14">
                      <span>{{moment(item.from, 'YYYY-MM-DD HH:mm:ss').format('MMM')}}</span>
                    </div>
                    <div class="bold-32">
                      <span>
                        <span>{{moment(item.from, 'YYYY-MM-DD HH:mm:ss').format('DD')}}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="p-2 ml-2 w-100">
                    <div class="text-muted regular-14">
                      <i class="fas fa-clock mr-2" />
                      <span>{{moment(item.from, 'YYYY-MM-DD HH:mm:ss').format('hh:mm a')}}</span>
                      <span> - </span>
                      <span>{{moment(item.to, 'YYYY-MM-DD HH:mm:ss').format('hh:mm a')}}</span>
                    </div>
                    <div class="bold-16 mt-2">
                      <a :href="`/workshops/${member.id}/schedules/${item.id}`" target="_blank">
                        <span class="typo-color-blue cursor-pointer">
                          {{ item.title }}
                        </span>
                      </a>
                    </div>
                </div>
              </div>
            </b-card>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	name: "TalksTab",
	props: ["workshops"],
	data() {
		return {
			search: "",
			sort: "alphabetically",
			options: [{ text: "Alphabetically", value: "alphabetically" }],
		}
	},
}
</script>
